import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

//Components
import Header from "./Header"
import Content from "./Content"
import Sidebar from "./Sidebar"
import { authenticationService } from "../../api/authentication.service"

function MainStructure(props) {
    const location = useLocation()
    const hasSession = !!authenticationService.currentUserValue
    const showSidebar = props.showSidebar ?? hasSession
    const [isMobileNavigationOpen, setIsMobileNavigationOpen] = useState(false)

    useEffect(() => {
        setIsMobileNavigationOpen(false)
    }, [location.pathname])

    useEffect(() => {
        document.body.classList.toggle("navigation-open", isMobileNavigationOpen)
        return () => document.body.classList.remove("navigation-open")
    }, [isMobileNavigationOpen])

    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape") setIsMobileNavigationOpen(false)
        }
        document.addEventListener("keydown", handleEscape)
        return () => document.removeEventListener("keydown", handleEscape)
    }, [])
    
    return (
        <React.Fragment>
            <div className="max-screen app-shell">
                <Header
                    onAuthenticate={props.onAuthenticate}
                    showNavigationToggle={showSidebar}
                    isNavigationOpen={isMobileNavigationOpen}
                    onNavigationToggle={() => setIsMobileNavigationOpen((open) => !open)}
                />
                <div className="max-screen__bottom flexer main-structure__bottom">
                    {showSidebar ? (
                        <Sidebar
                            isMobileOpen={isMobileNavigationOpen}
                            onClose={() => setIsMobileNavigationOpen(false)}
                        />
                    ) : null}
                    <Content className="main-structure__content">
                        {props.children}
                    </Content>
                </div>
            </div>
        </React.Fragment>
    )
}

export default MainStructure
